import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { FileDownload } from '@mui/icons-material';

const TeacherReportsGrid = ({ data, onExportCSV }) => {
  const navigate = useNavigate();

  const handleCourseClick = (courseId) => {
    if (courseId) {
      navigate(`/teacher/course/${courseId}`);
    }
  };

  const columns = [
    {
      field: 'teacher',
      headerName: 'Docente',
      flex: 1.2,
      minWidth: 120,
      renderCell: (params) => {
        return params.value || '';
      }
    },
    {
      field: 'course',
      headerName: 'Corso',
      flex: 1.5,
      minWidth: 150,
      renderCell: (params) => {
        const courseId = params.row.courseId;
        const courseName = params.value || 'Nessun corso';
        
        if (courseId && courseName !== 'Nessun corso') {
          return (
            <Typography
              onClick={() => handleCourseClick(courseId)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                color: '#1976d2', // Classic blue link color
                cursor: 'pointer',
                textDecoration: 'none',
                '&:hover': {
                  color: '#1565c0', // Darker blue on hover
                  textDecoration: 'underline'
                }
              }}
            >
              {courseName}
            </Typography>
          );
        }
        return courseName;
      }
    },
    {
      field: 'totalEnrollments',
      headerName: 'Iscritti',
      flex: 0.8,
      minWidth: 80,
      type: 'number',
      renderCell: (params) => {
        return params.value || 0;
      }
    },
    {
      field: 'suspendedEnrollments',
      headerName: 'Iscritti Sospesi',
      flex: 0.8,
      minWidth: 120,
      type: 'number',
      renderCell: (params) => {
        return params.value || 0;
      }
    },
    {
      field: 'datesRatio',
      headerName: 'Date',
      flex: 0.8,
      minWidth: 80,
      type: 'string',
      renderCell: (params) => {
        return params.value || '0/0';
      }
    },
    {
      field: 'averagePresent',
      headerName: 'Presenti Medi',
      flex: 0.8,
      minWidth: 80,
      type: 'number',
      renderCell: (params) => {
        return params.value || 0;
      }
    },
    // {
    //   field: 'totalPayments',
    //   headerName: 'Numero Pagamenti',
    //   flex: 0.8,
    //   minWidth: 100,
    //   type: 'number',
    //   renderCell: (params) => {
    //     return params.value || 0;
    //   }
    // },
    // {
    //   field: 'totalAmount',
    //   headerName: 'Totale Euro',
    //   flex: 0.8,
    //   minWidth: 80,
    //   type: 'number',
    //   valueFormatter: (params) => {
    //     return `€${params}`;
    //   }
    // }
  ];

  // console.log(data);
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h6" gutterBottom>
        Report Docenti
      </Typography>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        In questa pagina vengono mostrati i report dei docenti con statistiche per ogni corso.
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 1, mb: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          startIcon={<FileDownload />}
          color="primary"
          onClick={onExportCSV}
          disabled={!data || data.length === 0}
          size="small"
        >
          Esporta CSV
        </Button>
      </Box>

      <Paper sx={{  width: '100%' }}>
        <DataGrid
          rows={data}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 25, page: 0 },
            },
          }}
          rowsPerPageOptions={[25, 50, 100]}
          disableSelectionOnClick
          getRowId={(row) => row.id}
          sx={{
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid #e0e0e0',
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#f5f5f5',
              borderBottom: '2px solid #e0e0e0',
            },
          }}
        />
      </Paper>
    </Box>
  );
};

export default TeacherReportsGrid;
